export default __webpack_public_path__ + "static/media/icon-2.7a299a36.svg";